// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wE","title":"e_xE","wavy":"e_yE","navLink":"e_zE","active":"e_AE","iconArrow":"e_BE"};